import { Toaster } from "ngx-toast-notifications";

let toast;

export const showToast = (toaster: Toaster, msg, success, autoclose?) => {
    hideToast();
    createToastHelper(toaster, msg, success, autoclose);
}
export const hideToast = () => {
    const previous = toast;
    toast = undefined;

    if (previous) {
        try {
            previous.close();
        } catch (error) {
            // An in-app navigation destroys the host but not this handle, and the throw
            // used to swallow the toast that was replacing it.
            toast = undefined;
        }
    }
}

export const createToastHelper = (toaster: Toaster, msg, success, autoclose?) => {
    toast = toaster.open({
        text: msg || 'Hubo un error', 
        caption: success? 'Listo!' : 'Error', 
        duration: 4000,
        autoClose: autoclose || false,
        position: 'top-right',
        type: success? 'success' : 'danger',
        preventDuplicates: true
    });
}